import { RESTError } from "../core/RESTError";

/**
 * An error that is used as default REST error.
 */
export class DefaultRESTError extends RESTError {}
